<template>
  <div v-if="reportLoaded">
    <root-cause-analysis-history-report-card
      v-for="(reportData, index) of report.results"
      :key="index"
      :report-data="reportData"
      :start-date="startDate"
      :end-date="endDate"/>
  </div>
</template>

<script>
import RootCauseAnalysisHistoryReportCard from '@/components/report/performance-dashboard/RootCauseAnalysisHistoryReportCard'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import ReportMixin from '@/components/report/ReportMixin'
import { get } from 'lodash'

export default {
  name: 'RootCauseAnalysisHistoryReport',
  components: {
    RootCauseAnalysisHistoryReportCard
  },
  mixins: [
    CurrentUserMixin,
    ReportMixin
  ],
  computed: {
    /**
     * The start date of the report.
     */
    startDate () {
      return get(this, 'report.parameters.startDate')
    },
    /**
     * The end date of the report.
     */
    endDate () {
      return get(this, 'report.parameters.endDate')
    }
  }
}
</script>
